// Services.jsx
import axios from 'axios';
import ServiceCard from "./ServiceCard";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Services = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  useEffect(() => {
    const user_token = Cookies.get('user_token');
    const admin_token = Cookies.get('Admin_token');
    if (!user_token && !admin_token) {
      navigate('/login');
    }
  }, [navigate]);

  const getServices = async () => {
    try {
      const response = await axios.get('https://land-survey-main-server.onrender.com/getServices');
      setServices(response.data.services);
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <div className="px-4 py-16 mx-auto max-w-7xl">
      <h2 className="text-3xl font-extrabold tracking-tight text-center text-gray-800">
        Our Land Surveying Services
      </h2>
      
      {/* Responsive layout grid wrapper */}
      <section className="grid grid-cols-1 gap-8 mt-12 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <ServiceCard
            key={i}
            img={s.service_image}
            title={s.service_name} // Added missing title assignment string mapping
            description={s.description}
            service={s}
          />
        ))}
      </section>
    </div>
  );
};

export default Services;